import {
  Box,
  // Button,
  VStack,
} from "@chakra-ui/react";
import { colors, HStack, VLine } from "goi_common";

import HospiceMapLayout from "./HospiceMap";
import MoreFacilityImage from "./MoreFacilityImage";

function FacilityInformationSection({ hospice }: { hospice: any }) {
  const serviceType = hospice.services.map((res: string, i: number) => {
    if (hospice.services.length === i + 1) {
      return res;
    } else {
      return res + ", ";
    }
  });
  return (
    <>
      <Box padding="32px 20px">
        <table style={{ width: "100%" }}>
          <VStack as="tbody" style={{ gap: "8px" }} alignItems="start">
            <TableRow title="기관종류" description={hospice.managed_type} />
            <TableRow title="서비스 유형" description={serviceType} />
            <TableRow title="문의전화" description={hospice.telephone} />
            <TableRow title="홈페이지" description={hospice.homepage} />
            <TableRow title="주소" description={hospice.address} />
            <TableRow
              title="인력현황"
              description={hospice.human_resource_status}
            />
            <TableRow
              title="보조인력 제공"
              description={hospice.has보조인력 ? "있음" : "없음"}
            />
          </VStack>
        </table>

        {/* <Button
          className="button_16_sb"
          style={{
            color: "white",
            background: colors.black,
            width: "100%",
            height: "50px",
            borderRadius: "5px",
            margin: "30px 0px 30px 0px",
          }}
          onClick={() => {
            customEvent({
              newGtm: {
                path: "hospice_detail",
                trigger_and_target: "CTA_call",
              },
            });
            call("1666-9784");
          }}
        >
          호스피스 문의하기
        </Button> */}

        <Box mt="8px">
          <HospiceMapLayout
            latitude={hospice.latitude}
            longitude={hospice.longitude}
          />
        </Box>
        {hospice.images.length > 0 && (
          <>
            <VLine
              width="100%"
              height="10px"
              color={colors.gray50}
              margin="24px 0 12px"
            />
            <MoreFacilityImage name={hospice.name} images={hospice.images} />
          </>
        )}
      </Box>
    </>
  );
}

export default FacilityInformationSection;

const TableRow = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  return (
    <HStack as="tr">
      <Box as="td" className="body3_r gray700" minWidth="105px">
        {title}
      </Box>
      <Box as="td" className="body3_m gray900" wordBreak="keep-all">
        {description}
      </Box>
    </HStack>
  );
};
